<ng-container *ngIf="pillData?.length">
  <div *ngFor="let pill of pillData">
    <div (click)="onClick(pill.value)"><nv-pill-v4 [color]="pill.pillColor" [text]="pill.value"></nv-pill-v4></div>
  </div>
</ng-container>
